export const DISTRICTS = [
  {
    id: 'residential_north',
    name: 'Residential North',
    type: 'home',
    color: '#8b5cf6',
    description: 'home | sleep | quiet blocks',
    position: { x: 30, y: 20 },
    size: { w: 18, h: 14 },
  },
  {
    id: 'residential_east',
    name: 'Residential East',
    type: 'home',
    color: '#8b5cf6',
    description: 'home | sleep | quiet blocks',
    position: { x: 70, y: 25 },
    size: { w: 18, h: 14 },
  },
  {
    id: 'residential_west',
    name: 'Residential West',
    type: 'home',
    color: '#8b5cf6',
    description: 'home | sleep | quiet blocks',
    position: { x: 15, y: 55 },
    size: { w: 18, h: 14 },
  },
  {
    id: 'neon_commercial',
    name: 'Neon Commercial',
    type: 'commercial',
    color: '#fda29b',
    description: 'shops | convenience | grocery',
    position: { x: 50, y: 50 },
    size: { w: 20, h: 16 },
  },
  {
    id: 'recreation_quarter',
    name: 'Recreation Quarter',
    type: 'recreation',
    color: '#32d583',
    description: 'gym | park | outdoor',
    position: { x: 75, y: 65 },
    size: { w: 18, h: 14 },
  },
  {
    id: 'social_hub',
    name: 'Social Hub',
    type: 'social',
    color: '#fbbf24',
    description: 'bars | cafes | rooftops',
    position: { x: 35, y: 75 },
    size: { w: 18, h: 14 },
  },
  {
    id: 'transit_core',
    name: 'Transit Core',
    type: 'transit',
    color: '#53b1fd',
    description: 'metro | commute | transit',
    position: { x: 55, y: 35 },
    size: { w: 16, h: 12 },
  },
];

// Map locationType from activityConfig to district id
export const LOCATION_TYPE_TO_DISTRICT = {
  home: (agentId) => {
    const homes = {
      'agent-1': 'residential_north',
      'agent-2': 'residential_east',
      'agent-3': 'residential_west',
    };
    return homes[agentId] || 'residential_north';
  },
  commercial: () => 'neon_commercial',
  recreation: () => 'recreation_quarter',
  social: () => 'social_hub',
  transit: () => 'transit_core',
};

// Map work zones to city districts
export const WORK_ZONE_TO_DISTRICT = {
  engineering: 'neon_commercial',
  research: 'neon_commercial',
  comms: 'transit_core',
  logistics: 'transit_core',
  strategy: 'neon_commercial',
};

export function getDistrictForAgent(agent) {
  // Life mode — locationTag format: "districtId_activityKey"
  if (agent.locationTag) {
    // Extract district ID (everything before the last underscore-separated activity)
    // District IDs can contain underscores (e.g. residential_north)
    // Activity keys can also contain underscores (e.g. watching_tv)
    // Try matching known district IDs first
    for (const d of DISTRICTS) {
      if (agent.locationTag.startsWith(d.id + '_')) {
        return d;
      }
    }
    // Legacy fallback: agentId_locationType format
    const parts = agent.locationTag.split('_');
    const locationType = parts.slice(1).join('_');
    const resolver = LOCATION_TYPE_TO_DISTRICT[locationType];
    if (resolver) {
      const districtId = typeof resolver === 'function' ? resolver(agent.id) : resolver;
      const d = DISTRICTS.find((dd) => dd.id === districtId);
      if (d) return d;
    }
  }

  // Work mode — use currentZoneId
  if (agent.currentZoneId && agent.currentZoneId !== 'life') {
    const districtId = WORK_ZONE_TO_DISTRICT[agent.currentZoneId];
    if (districtId) return DISTRICTS.find((d) => d.id === districtId) || null;
  }

  return null;
}
